/**
 * Cloud demo only: remove legacy browser keys that used to override entity / invoice header
 * (e.g. old setup wizard or qawaem-settings.company) so papers use /data/settings.json + app defaults.
 */
export function clearLegacyDemoEntityStorage() {
  try {
    localStorage.removeItem('setup_data');
    localStorage.removeItem('settings');

    const raw = localStorage.getItem('qawaem-settings');
    if (!raw) return;

    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return;

    delete parsed.company;
    localStorage.setItem('qawaem-settings', JSON.stringify(parsed));
  } catch (e) {
    console.warn('[demo] clearLegacyDemoEntityStorage:', e);
  }
}
